const FABLEBORNE_CDN_URL = 'https://cdn.fableborne.com/fab';
const WEB_SHOP_CDN_URL = 'https://web-shop-assets.s3.eu-central-1.amazonaws.com';
const MINT_EXP_CDN_URL = 'https://mint-exp.s3.eu-central-1.amazonaws.com';

export const CDN_URLS = {
  FABLEBORNE: FABLEBORNE_CDN_URL,
  WEB_SHOP: WEB_SHOP_CDN_URL,
  MINT_EXP: MINT_EXP_CDN_URL,
};
